import { render } from "./section1.vue?vue&type=template&id=5c9e8dc4"
import script from "./section1.vue?vue&type=script&lang=js"
export * from "./section1.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__